import React from "react";

interface IProps {
    pcode: string;
    message: string;

    onClose: (e: React.MouseEvent) => void;
}

export default class BetConfirmedModal extends React.Component<IProps> {
    render() {
		const { pcode, message, onClose } = this.props;
		const pcodeProp = {pcode: pcode};

        return (
            <div className="modal-container"
                onClick={onClose}>

                <div className="betmodal-gradient"
                    {...pcodeProp}
                    onClick={onClose}>

                    <div className="betmodal-status-true">
                        {message}
                    </div>
                </div>
            </div>
        );
    }
}